"use client";

import { c as _c } from "react/compiler-runtime";
import DropListItemContentMediaImage from "@/components/drops/view/item/content/media/DropListItemContentMediaImage";
interface DropPartMarkdownImageProps {
  readonly src: string;
}
export default function DropPartMarkdownImage(t0) {
  const $ = _c(2);
  const {
    src
  } = t0;
  let t1;
  if ($[0] !== src) {
    t1 = <div className="tw-relative tw-mt-2 tw-h-64 tw-w-full"><DropListItemContentMediaImage src={src} loadStrategy="eager" /></div>;
    $[0] = src;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}